import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Fade, FadeSlideinOut } from 'src/animations';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { WeatherBonusOrchestratorService } from 'src/app/core/helpers/weather-bonus-orchestrator.service';


export enum ScanningState {
  Idle = 'idle',
  Scanning = 'scanning',
  Completed = 'completed',
  // Add other states as needed
}

@Component({
  selector: 'loyaltic-pof-live',
  templateUrl: './pof-live.component.html',
  styleUrls: ['./pof-live.component.scss'],
  animations: [Fade, FadeSlideinOut]
})

export class PofLiveComponent implements OnInit {
  @Output() imageSelected = new EventEmitter<File>();

  fileSelected = false;
  submitted = false;
  fileName = '';
  productList: any;
  productQuantity = new Array(10);
  selectedProducts = [
    {productName:'', quantity: 0}
  ]
  Quantity = 1;
  receipt: any;
  receiptSrc: any;

  scanningData = [
    
  ]

  List :any[] = [];

  imageData: string | ArrayBuffer | null = '';

  scanningState: ScanningState = ScanningState.Idle

  isLoading = false;  // property for loading state
  loadError = '';     // property for storing loading errors

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.receipt = event.target.files[0];
    if (file) {
      this.isLoading = true; // Start loading
      this.loadError = '';   // Reset previous errors

      const reader = new FileReader();

      reader.onload = e => {
        this.imageData = reader.result;
        this.isLoading = false; // Stop loading
      };

      reader.onerror = e => {
        console.error('FileReader error', e);
        this.loadError = 'Error reading file';
        this.isLoading = false; // Stop loading
      };

      reader.readAsDataURL(file);
      this.fileSelected = true;
      this.fileName = file.name;
    }
  }

  capture() {
    // Logic to capture the image from the camera
    // This might involve using a separate library or API
  }
  startScanning() {
    this.submitted = true;
    this.scanningState = ScanningState.Scanning;

    const userId = this.authService.getUserId();
    const IsReUpload = localStorage.getItem('IsReUpload');

    this.selectedProducts.map((prod:any) => {
      let product = this.productList.filter((produ:any) => produ.name === prod.productName)[0];
      let data = {
        'ProductName': prod.productName,
        'Quantity': prod.quantity, 
        'PointsPerProduct':product.pointsPerProduct
      }
      this.List.push(data);
    })

    
    const formData = new FormData();
    formData.append("UserId", userId);
    formData.append("Quantity", this.Quantity.toString());
    formData.append("Culture", this.translate.getDefaultLang());
    formData.append("File", this.receipt);
    formData.append("IsReUpload", IsReUpload === "1" ? "true" : "false");
    formData.append("Purchases", JSON.stringify(this.List));

    this.coreService
      .upLoadReceipt(formData)
      .then(async (res: any) => {
        const rejectedReasons = res.result.rejectedReasons || [];
        rejectedReasons.indexOf('product-not-found') === -1 ? this.scanningData.push('Product Found: Yes') : this.scanningData.push('Product Found: No');
        rejectedReasons.indexOf('invalid-purchase-date-time') === -1 ? this.scanningData.push('Date Ok: Yes') : this.scanningData.push('Date Ok: No');
        rejectedReasons.indexOf('potential-duplicate-receipt') === -1 ? this.scanningData.push('Duplicate Receipt: No') : this.scanningData.push('Duplicate Receipt: Yes');
        this.coreService.isReceiptApproved = res.result.isapproved;
        this.coreService.scanningReasons = this.scanningData;

        if (!res.result.isapproved) {
          this.coreService.recptPartitionKey = res.result.recptPartitionKey;
          this.coreService.recptRowKey = res.result.recptRowKey;
        } else {
          await this.weatherBonusOrchestrator.applyFromUploadResult(res.result);
        }
        
        this.coreService.responseLoadedEmitter.emit(true);
      })
      .catch((errorResponse: any) => {
        // this.resetForm();
        const errorMessage = this.translate.instant(
          errorResponse.error.messageKey
        );
        this.toast.error(errorMessage, "");
        return;
      });
  }


  cancelScan() {
    this.imageData = null;     // Clear the selected image
    this.fileSelected = false; // Reset the fileSelected flag
    this.fileName = '';        // Clear the file name
    this.scanningState = ScanningState.Idle;
  }
  constructor( private authService: AuthService,
      private coreService: CoreService,
      private toast: ToastrService,
      private translate: TranslateService,
      private router: Router,
      private dataService: DataServiceService,
      private modalService: BsModalService,
      private gaService: GaService,
      private weatherBonusOrchestrator: WeatherBonusOrchestratorService) { }

  ngOnInit() {
    this.coreService.getProducts().then((res: any) => {
      console.log('producs', res.result.purchasedProducts);
      this.productList = res.result.purchasedProducts;
    })
  }

  addMoreProduct() {
    let prod = {productName:'', quantity: 0};
    this.selectedProducts.push(prod);
  }

  removeProduct() {
    this.selectedProducts.pop();
  }

}
